import "./App.css";
import Home from "./coponents/Home";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
  return (
    <div className="App">
      <Home />
      <SpeedInsights />
      <Analytics />
    </div>
  );
}

export default App;
